import * as React from "react";
import {Job3ItemListItem} from "./Job3ItemListItem";


export function Job3ItemList(props) {
    return (<div className="job-3item-list">
        {React.Children.map(props.children, child => (<Job3ItemListItem>{child}</Job3ItemListItem>))}
    </div>)
}
